import empty from '@/views/default/empty'
import MasterData from "@/views/maintain/MasterData"
import Workflow from "@/views/maintain/Workflow"
import RoleMaintain from "@/views/maintain/RoleMaintain"
import FunctionMaintain from "@/views/maintain/FunctionMaintain"
import UserMaintain from "@/views/maintain/UserMaintain"
import Announcement from "@/views/maintain/Announcement"
import JobSchedule from "@/views/maintain/JobSchedule"
import ContactPerson from "@/views/maintain/ContactPerson"
import ReceivingDownload from "@/views/maintain/ReceivingDownload"
export default [
  {
    path: '/maintain',
    name: 'Maintain',
    component: empty,
    children: [
      {
        path: "transfer-approver-list",
        name: "TRANSFER_APPROVER_LIST",
        meta: { externalUrl: '/vue3/#/maintain/transfer-approver-list', tag: "toVue3" },
        component: empty,
      }, 
      {
        path: "pcneol-workflow-maintain",
        name: "PCNEOL_WORKFLOW_MAINTAIN",
        meta: { externalUrl: '/vue3/#/maintain/pcneol-workflow-maintain', tag: "toVue3" },
        component: empty,
      },
      {
        path: "master-data",
        name: "MASTER_DATA_MAINTAIN",
        component: MasterData,
      }, 
      {
        path: "workflow",
        name: "QUOTATION_WORKFLOW_MAINTAIN",
        component: Workflow,
      }, 
      {
        path: "ap-exclusion-list",
        name: "SYSTEM_DATA_MAINTAIN_AP_EXCLUSION_LIST_MAINTAIN",
        meta: { tag: "toVue3" },
        component: empty,
      }, 
      {
        path: "RoleMaintain",
        name: "ROLE_MAINTAIN",
        component: RoleMaintain,
      },
      {
        path: "FunctionMaintain",
        name: "FUNCTION_MAINTAIN",
        component: FunctionMaintain,
      },
      {
        path: "UserMaintain",
        name: "USER_MAINTAIN",
        component: UserMaintain,
      },
      {
        path: "Announcement",
        name: "ANNOUNCEMENT_MAINTAIN",
        meta: { externalUrl: "/vue3/#/maintain/announcement", tag: "toVue3" },
        component: Announcement,
      },
      {
        path: "JobSchedule",
        name: "JOB_SCHEDULING",
        component: JobSchedule,
      },
      {
        path: "ContactPerson",
        name: "CONTACT_PERSON",
        component: ContactPerson,
      },
      {
        path: "receiving-download",
        name: "RECEIVING_DOWNLOAD",
        component: ReceivingDownload,
      },
    ]
  }
]
